"use client";

import NotFoundPage from "@/views/errors/NotFoundPage";

export default function NotFound() {
  return <NotFoundPage />;
}
